module.exports = __webpack_public_path__ + "img/7.5ef06485.jpg";